import * as SpecificationSearchModels from '../../models/specification/specificationSearch';
import * as SpecificationModels from '../../models/specification/specification';
import * as Models from '../../models/commonModels';
import * as CarModels from '../../models/car/car';

export class GetSpecificationList {
  static readonly type = '[Specification] GetSpecificationList';
  constructor(public search: SpecificationSearchModels.SpecificationSearchModel) { }
}

export class GetSpecificationListSummary {
  static readonly type = '[Specification] GetSpecificationListSummary';
  constructor(public search: SpecificationSearchModels.SpecificationSearchModel) { }
}

export class GetSpecificationReportFiltered {
  static readonly type = '[Specification] GetSpecificationReportFiltered';
  constructor(public search: SpecificationSearchModels.SpecificationSearchModel, public ReportName: string) { }
}


export class GetSpecificationReportDetailed {
  static readonly type = '[Specification] GetSpecificationReportDetailed';
  constructor(public search: SpecificationSearchModels.SpecificationSearchModel, public ReportName: string) { }
}

export class GetSpecificationReportDetailedAfterSale {
  static readonly type = '[Specification] GetSpecificationReportDetailedAfterSale';
  constructor(public search: SpecificationSearchModels.SpecificationSearchModel, public ReportName: string) { }
}

export class GetSpecificationReportReplacementAndSeasoning {
  static readonly type = '[Specification] GetSpecificationReportReplacementAndSeasoning';
  constructor(public search: SpecificationSearchModels.SpecificationSearchModel, public ReportName: string) { }
}

export class GetExchangeVerificationReport {
  static readonly type = '[Specification] GetExchangeVerificationReport';
  constructor(public FileName: string, public Data: any, public ReportName: string) { }
}

export class GetExchangeServicesReport {
  static readonly type = '[Specification] GetExchangeServicesReport';
  constructor(public Data: any, public ReportName: string) { }
}

export class GetSpecificationStatusesDictionary {
  static readonly type = '[Specification] GetSpecificationStatusesDictionary';
  constructor() { }
}

export class SetSpecificationSearch {
  static readonly type = '[Specification] SetSpecificationSearch';
  constructor(public Search: SpecificationSearchModels.SpecificationSearchModel) { }
}

export class SetSpecificationListPage {
  static readonly type = '[Specification] SetSpecificationListPage';
  constructor(public Search: SpecificationSearchModels.SpecificationSearchModel) { }
}

export class ResetSpecificationSearch {
  static readonly type = '[Specification] ResetSpecificationSearch';
  constructor() { }
}

export class NullSpecificationSearch {
  static readonly type = '[Specification] NullSpecificationSearch';
  constructor() { }
}

// this action state is responsible for clear the upload form,
export class SetImportStatus {
  static readonly type = '[Specification] ChangeImportStatus';
  constructor(public status: boolean) { }
}

export class HideListItems {
  static readonly type = '[Specification] HideListItem';
  constructor(public Specifications: SpecificationModels.SpecificationModel[], public Search?: SpecificationSearchModels.SpecificationSearchModel) { }
}

export class ShowListItem {
  static readonly type = '[Specification] ShowListItem';
  constructor(public SpecificationId: number) { }
}

export class ShowAllListItem {
  static readonly type = '[Specification] ShowAllListItem';
  constructor() { }
}

export class SetWorkMode {
  static readonly type = '[Specification] SetWorkMode';
  constructor(public Mode: SpecificationModels.WorkMode) { }
}

export class GetSpecificationPreviewList {
  static readonly type = '[Specification] GetSpecificationPreviewList';
  constructor(public search: SpecificationSearchModels.SpecificationPreviewSearchModel) { }
}


export class ImportAutoryzation {
  static readonly type = '[Specification] ImportAotoryzation';
  constructor(public FileName: string, public Data: any) { }
}

// this action state is responsible for clear the upload form,
export class SetImportAutorizationStatus {
  static readonly type = '[Specification] SetImportAutorizationStatus';
  constructor(public Status: boolean) { }
}

export class GetSpecificationReportCost {
  static readonly type = '[Specification] GetSpecificationReportCost';
  constructor(public Search: SpecificationSearchModels.SpecificationSearchModel, public ReportName: string) { }
}

export class GetSpecificationReportAutorizationCost {
  static readonly type = '[Specification] GetSpecificationReportAutorizationCost';
  constructor(public Search: SpecificationSearchModels.SpecificationSearchModel, public ReportName: string) { }
}

export class New {
  static readonly type = '[Specification] New';
  constructor(public Specificatoin: Models.Request<SpecificationModels.SpecificationModel>, public FileUpload1: File, public FileUpload2: File) { }
}

export class NewSpecificationDetails {
  static readonly type = '[Specification] New Specification Details';
  constructor(public Specificatoin: Models.ContextRequest<SpecificationModels.SpecificationModel, SpecificationModels.SpecificationDetailsModel>) { }
}

export class DeleteSpecificationDetails {
  static readonly type = '[Specification] Delete Specification Details';
  constructor(public Specificatoin: Models.ContextRequest<SpecificationModels.SpecificationModel, SpecificationModels.SpecificationDetailsModel>) { }
}

export class AccepSpecificationDetails {
  static readonly type = '[Specification] Accep Specification Details';
  constructor(public Specificatoin: Models.ContextRequest<SpecificationModels.SpecificationModel, SpecificationModels.SpecificationDetailsModel>) { }
}

export class RejectSpecificationDetails {
  static readonly type = '[Specification] Reject Specification Details';
  constructor(public Specificatoin: Models.ContextRequest<SpecificationModels.SpecificationModel, SpecificationModels.SpecificationDetailsModel>) { }
}

export class SetSpecificationDetails {
  static readonly type = '[Specification] Set Specification Details';
  constructor(public Specificatoin: Models.ContextRequest<SpecificationModels.SpecificationModel, SpecificationModels.SpecificationDetailsModel>) { }
}

export class Set {
  static readonly type = '[Specification] Set';
  constructor(public Specificatoin: Models.Request<SpecificationModels.SpecificationModel>) { }
}

export class Get {
  static readonly type = '[Specification] Get';
  constructor(public SpecificatoinId: Models.RequestModel) { }
}


export class SetFile {
  static readonly type = '[Specification] Set File';
  constructor(public Specificatoin: Models.Request<SpecificationModels.SpecificationModel>, public FileIndex:number, public File: File) { }
}

export class GetFile {
  static readonly type = '[Specification] Get File';
  constructor(public Specificatoin: Models.ContextRequest<SpecificationModels.SpecificationModel, number>) { }
}

export class DeleteFile {
  static readonly type = '[Specification] Delete File';
  constructor(public Specificatoin: Models.ContextRequest<SpecificationModels.SpecificationModel, number>) { }
}

export class GenerateSpecyficationReport {
  static readonly type = "[Specyfication] Generate Specyfication Report";
  constructor(public Specyfication: Models.Request<SpecificationModels.SpecyficationReportModel>) { }
}

export class Create {
  static readonly type = '[Specification] Create';
  constructor(public Specificatoin: Models.Request<SpecificationModels.SpecificationModel>) { }
}

export class ChangeCar {
  static readonly type = '[Specification] Change Car';
  constructor(public Specificatoin: Models.ContextRequest<SpecificationModels.SpecificationModel, CarModels.CarModel>) { }
}

export class SetSpecificationNote {
  static readonly type = '[Specification] Set Specification Note';
  constructor(public SpecificationNote: Models.Request<SpecificationModels.SpecificationNoteModel>) { }
}

export class GetSpecificationNotes {
  static readonly type = '[Specification] Get Specification Notes';
  constructor(public SpecificatoinId: Models.RequestModel) { }
}

export class SetSpecificationDetailNote {
  static readonly type = '[Specification] Set SpecificationDetail Note';
  constructor(public SpecificationDetailNote: Models.Request<SpecificationModels.SpecificationDetailNoteModel>) { }
}

export class GetSpecificationDetailNotes {
  static readonly type = '[Specification] Get SpecificationDetail Notes';
  constructor(public SpecificationDetailId: Models.RequestModel) { }
}


export class UpdateExcludeSpecificationIds {
  static readonly type = '[Specification] Exclude Specification Ids';
  constructor(public ExcludeSpecificationIds: number[]) { }
}
